<template>
  <div class="landing-page">
    <!-- Header -->
    <header style="background: #f5f5f5; padding: 10px 20px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); position: fixed; top: 0; width: 100%; z-index: 100;">
      <div style="max-width: 1200px; margin: auto; display: flex; align-items: center; justify-content: space-between;">
        <!-- Contenedor logo y eslogan -->
        <div class="logo-container" style="display: flex; align-items: center; gap: 15px;">
          <v-img 
            class="logo"
            :aspect-ratio="1"
            max-width="50"
            :src="require('@/assets/logos/frame 82.png')"
            @click="$router.push('/home')"
            style="cursor: pointer; object-fit: contain;"
          ></v-img>
          <div style="color: #003366; font-weight: bold; line-height: 1.2; font-size: 10px;">
            <p style="margin: 0;">Termina</p>
            <p style="margin: 0;">La Secundaria</p>
            <p style="margin: 0;">Adultos</p>
          </div>
        </div>

        <!-- Enlace "INSCRIPCIÓN ONLINE" -->
        <div class="nav-container">
          <ul style="list-style: none; display: flex; gap: 10px; margin: 0; padding: 0; align-items: center; font-size: 14px;">
            <li class="inscripcion-online">
              <a href="https://wa.me/5491172157002" style="color: #4a4a4a; text-decoration: none; font-weight: bold;" target="_blank">INSCRIPCIÓN ONLINE</a>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <!-- Hero Section -->
    <section id="hero" class="hero" :style="{ backgroundImage: `url(${require('@/assets/logos/BCE-HERO.jpg')})` }">
      <div class="overlay"></div>

      <!-- Text Content -->
      <div class="text-content">
        <div v-for="(text, index) in texts" :key="index" class="text-section">
          <h2 class="text-title">{{ text.title }}</h2>
          <p class="text-description" v-html="text.description"></p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button @click="goToSignup">INSCRIBIRME</button>
        <button @click="goToContact">CONTACTO</button>
        <button @click="goToDashboard">INGRESAR A AUTOGESTIÓN</button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      texts: [
  {
    title: "Termina la Secundaria - Adultos: ¡Es tu Momento de Lograrlo!",
    description: "¿Has pensado en las puertas que se abrirán al terminar la secundaria? En BCE, te ofrecemos la oportunidad de completar tus estudios y alcanzar tus metas profesionales y personales. Sabemos que la educación es la clave para un futuro mejor, y estamos aquí para acompañarte en este importante paso."
  },
  {
    title: "Un Sistema Innovador: Estudio Modular",
    description: "En BCE, hemos implementado el Sistema de Estudio Modular, el diseño educativo más innovador del país. Olvidate de las materias tradicionales y sumergite en un método de aprendizaje que integra diferentes áreas a través de ejes temáticos. Este enfoque te permite entender cómo se conectan las distintas disciplinas en contextos reales y relevantes."
  },
  {
    title: "¿Cómo Funciona?",
    description: "En lugar de estudiar asignaturas aisladas, aprenderás a través de módulos temáticos que engloban varias materias. Por ejemplo:\n\nMódulo: Economía y Vida Social\n- Matemática: Analizá estadísticas económicas y tendencias financieras.\n- Historia: Explorá eventos históricos que han influido en la economía y la sociedad.\n- Literatura: Descubrí obras literarias que reflejan contextos económicos y sociales.\n- Ciencias Sociales: Comprendé las dinámicas entre la economía y el comportamiento humano."
  },
  {
    title: "Ventajas de Estudiar en BCE",
    description: "Evaluación Flexible: Si una materia se te complica, podés compensarla con mejores notas en otras dentro del mismo módulo.\nEnfoque Práctico y Actual: Estudiá temas relevantes que impactan en el mundo actual.\nHorarios Adaptables: Diseñados para ajustarse a tus responsabilidades y ritmo de vida.\nTítulo Oficial: BCE te ofrece un título oficial de la Ciudad de Buenos Aires, válido para ingresar a cualquier trabajo o a cualquier Universidad."
  },
  {
    title: "¿Por Qué Terminar la Secundaria?",
    description: "Terminar la secundaria es más que un logro académico; es una inversión en vos mismo. Te abre puertas a oportunidades laborales mejor remuneradas, te permite acceder a estudios superiores y es un paso fundamental para alcanzar tus objetivos. Termina la Secundaria y construí el futuro que siempre deseaste."
  },
  {
    title: "Diseñado para Vos",
    description: "En BCE, entendemos las necesidades de los adultos que desean retomar sus estudios. Por eso, ofrecemos:\n\n- Clases Adaptadas: Metodologías de enseñanza pensadas para adultos.\n- Soporte Constante: Un equipo docente comprometido con tu éxito."
  },
  {
  title: "Testimonios que Inspiran",
  description: `
    <p>"Decidí terminar la secundaria en BCE y fue la mejor decisión. El sistema modular hizo el aprendizaje más interesante y relevante para mi vida." – Laura, 32 años.</p>
    <p>"Gracias a BCE, pude estudiar mientras trabajaba y ahora tengo mejores oportunidades laborales." – Martín, 27 años.</p>
  `
},


  {
    title: "Comenzá Hoy Mismo",
    description: "No hay mejor momento que ahora para dar este importante paso. Termina la Secundaria en un entorno que se adapta a vos y a tus necesidades."
  },
  {
    title: "¿Cómo Inscribirte?",
    description: `Registrate en Nuestra Plataforma: Escribinos por <a href="https://wa.me/5491172157002" target="_blank" style="color: #4fa3f7;">WhatsApp</a> y hacé tu inscripción.\nElegí Tu Modalidad: Ofrecemos distintas opciones para que elijas la que mejor se adapta a tu vida.\nComenzá a Estudiar: Iniciá tu camino hacia la titulación con el apoyo de nuestros profesionales.`
  },

  {
    title: "Contacto",
    description: `Para contactarnos, puedes escribir a <a href="https://wa.me/5491172157002" target="_blank" style="color: #4fa3f7;">WhatsApp</a> o visitar nuestra dirección: Malvinas Argentinas 344, Ciudad Autónoma de Buenos Aires.`
  },

  {
    title: "Preguntas Frecuentes",
    description: "¿Necesito conocimientos previos?\nNo es necesario. Nuestro programa está diseñado para adaptarse a tu nivel actual y acompañarte en todo el proceso.\n\n¿Cómo es el sistema de evaluaciones?\nLas evaluaciones son integrales y flexibles, permitiéndote demostrar tus conocimientos de manera práctica.\n\n¿El título es oficial?\nSí, al finalizar tus estudios, obtendrás un título oficial reconocido en todo el país."
  },
  {
    title: "¡El Futuro Está en Tus Manos!",
    description: "En BCE, creemos en tu potencial y queremos ser parte de tu éxito. Termina la Secundaria y descubrí todas las oportunidades que te esperan. No importa los desafíos que hayas enfrentado antes, lo importante es el paso que estás dispuesto a dar hoy.\n\nSumate a BCE y construyamos juntos tu camino al éxito."
  }
],
    };
  },
  methods: {
    goToSignup() {
      this.$router.push({ name: "Signup" });
    },
    goToContact() {
      this.$router.push({ name: "Contact" });
    },
    goToDashboard() {
      this.$router.push("/home2");
    }
  }
};
</script>

<style scoped>
.hero {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
  color: #fff;
  background-size: cover;
  background-position: center;
  position: relative;
  padding: 100px 20px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hero::-webkit-scrollbar {
  display: none;
}

.text-content {
  max-height: 80%;
  overflow-y: auto;
  padding: 15px;
  text-align: center;
}

.text-content::-webkit-scrollbar {
  display: none;
}

.text-title {
  font-size: 2em;
  font-weight: 700;
  margin-bottom: 10px;
}

.text-description {
  font-size: 1.3em;
  font-weight: 500;
  white-space: pre-wrap;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: auto;
  padding-bottom: 30px;
}

.action-buttons button {
  background-color: #003366;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.action-buttons button:hover {
  background-color: #004080;
}

/* Media Queries */
@media (max-width: 768px) {
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .nav-container {
    display: flex;
    justify-content: flex-end;
  }

  /* Convierte el enlace INSCRIPCIÓN ONLINE en un botón en pantallas pequeñas */
  .inscripcion-online a {
    background-color: #003366;
    color: white !important; /* Forzamos el color blanco con !important */
    font-size: 12px; /* Reducimos el tamaño de la letra */
    padding: 8px 15px;
    text-decoration: none;
    font-weight: bold;
    border-radius: 5px;
    display: inline-block;
    transition: background-color 0.3s ease;
  }

  .inscripcion-online a:hover {
    color: white !important; /* Aseguramos que el color siga siendo blanco al pasar el mouse */
  }

  /* Los botones de la acción en columna */
  .action-buttons {
    flex-direction: column;
    gap: 15px;
    transform: translateY(42%); /* Aumentamos el margen superior para que los botones estén más abajo */
  }
}
</style>

